/* eslint-disable react/no-deprecated */
import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Iframe from 'react-iframe';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import { Divider } from '@material-ui/core';
import * as actions from '../../actions/index';
import { styles } from './WebDesign.styles';
import {
  initStates,
  setCroppedImage,
  handleRemoveImage,
  changeDesign,
  changeSwitchValue,
  changeSwitchValueMode,
  changeValueMode,
  getCommonBottomNavigationData
} from './WebDesign.services';
import Button from '../Button';
import Viewer from '../Viewer';
import Paper from '../Paper';
import Input from '../Input';
import Spinner from '../Spinner';
import DraggableImage from '../DraggableImage';
import BackButton from '../BackButton';
import { UNIT, marketing } from '../../constants';
import CommonBottomNavigation from '../CommonDesign/BottomNavigation/BottomNavigation.view';

const cropProps = {
  width: 'auto',
  height: UNIT * 10.6875,
  backgroundColor: '#F1F4F7',
  borderRadius: UNIT
};

// TODO remove mapStateToProps, use useSelector instead
function WebDesign({ imageCoverOrderUrl, classes, url, webapp, terminal, shopId, history = {}, openErrorModal }) {
  const [stateObj, setStateObjRaw] = useState({
    isLoading: true,
    spinner: false,
    loadingCropper: false,
    picture: [],
    image64: [],
    selected: 0,
    cartPhrase: '',
    selectedMenu: 0,
    selectedProduct: 0,
    random: 0,
  });
  const setStateObj = myNewObj => setStateObjRaw({ ...stateObj, ...myNewObj });
  const { enabled: enabledWebApp = false } = webapp;
  const { enabled: enabledTerminal = false } = terminal;
  const correctedUrl = enabledWebApp
    ? `${url}/commander`
    : enabledTerminal
      ? `${url}/terminal/${shopId}`
      : `${url}/qrcode/${shopId}`;
  useEffect(() => {
    initStates(setStateObj, webapp)
  }, []);

  const renderConfigCartPhrase = () => {
    return (
      <div>
        <p className={classes.designText}>
          Message du panier <HelpOutlineOutlinedIcon className={classes.helpIcon} />
        </p>

        <Input
          margin='dense'
          id='cartPhrase'
          type='text'
          variant='outlined'
          value={stateObj.cartPhrase}
          onChange={e => setStateObj({ cartPhrase: e.target.value })}
          className={classes.inputStyle}
          multiline
          placeholder='Ex:profitez de -20% de réduction sur...'
        />
      </div>
    );
  };

  const renderStyle = (title, value, idCheck) => {
    return (
      <div elevation={0} className={classes.paper}>
        <p className={classes.designText}>{title}</p>
        <CommonBottomNavigation
          collection={getCommonBottomNavigationData(classes, idCheck)}
          selectedMode={value}
          classes={classes}
          onChange={(event, newValue) => changeSwitchValueMode(event, newValue, setStateObj, idCheck)}
          onCheck={() => changeValueMode(stateObj.selectedMenu, stateObj.selectedProduct, idCheck, setStateObj)}
          idCheck={idCheck}
        />
      </div>
    );
  };

  const renderStrctureDesign = () => {
    return (
      <div className={`${classes.space} pt-4`}>
        {(webapp.enabled || terminal.enabled) &&
          renderStyle('Orientation du menu', stateObj.selectedMenu, 'menuCheck')}
        {renderStyle('Design des étiquettes produits', stateObj.selectedProduct, 'etiquetteCheck')}
      </div>
    );
  };

  const renderFirstStepDesign = () => {
    const { loadingCropper, picture } = stateObj;
    return (
      <div className={`${classes.space} pt-4`}>
        <p>
          <span className={classes.designText}>Bannière d'accueil </span> <i>(1 image maximum)</i>
        </p>

        <div className={classes.cropStyle}>
          <DraggableImage
            multiple={false}
            loadingCropper={loadingCropper}
            disableLoader={() => setStateObj({ loadingCropper: false })}
            maxFileSize={500000}
            picture={!Array.isArray(picture) ? [{ imageUrl: picture }] : picture}
            fileType
            isDesign
            setCroppedImage={croppedImage => setCroppedImage(croppedImage, setStateObj)}
            handleRemove={() => handleRemoveImage(setStateObj)}
            imgExtension={['.png', '.jpeg', '.jpg', 'jfif']}
            defaultText={"Drag & Drop l'image (500Ko max)"}
            cropProps={cropProps}
            aspect={3}
            cropStyle={classes.crop}
          />
        </div>
        <Divider className='my-2' />
        <div>{renderConfigCartPhrase()}</div>
      </div>
    );
  };

  const renderDesign = () => {
    return (
      <div className='col-md-6 col-lg-5 col-xl-4 pt-4'>
        <Paper>
          <Viewer
            value={stateObj.selected}
            onChange={(event, newValue) => changeSwitchValue(newValue, imageCoverOrderUrl, setStateObj)}
            buttonList={['Config', 'Style']}
          />
        </Paper>

        <div>
          {stateObj.selected === 0
            ? enabledWebApp
              ? renderFirstStepDesign()
              : renderStrctureDesign()
            : renderStrctureDesign()}
        </div>
        <div className='d-flex justify-content-center my-3 '>
          {stateObj.spinner ? (
            <center>
              <Spinner className={classes.progress} />
            </center>
          ) : (
            <Button onClick={() => changeDesign(stateObj, webapp, openErrorModal, setStateObj)} className={classes.buttonStyle}>
              ENREGISTRER
            </Button>
          )}
        </div>
      </div>
    );
  };


  return (
    <div className='p-4'>
      <BackButton
        className='p-0'
        onClick={() => history.goBack()}
        title={marketing.webDesign.text}
        subtitle={marketing.webDesign.description}
      />
      {stateObj.isLoading ? (
        <center>
          <Spinner className={classes.progress} />
        </center>
      ) : (
        <div>
          <Paper className={`${classes.body} mt-2`}>
            <div className={`row w-100 h-100 ${classes.marginStyle}`}>
              <div
                className={` col-md-6 col-lg-7 col-xl-8 mb-2 mb-md-0 h-100 ${classes.iframeStyle} `}
              >
                <Iframe
                  url={correctedUrl}
                  width='100%'
                  height={UNIT * 51}
                  id='myId'
                  key={stateObj.random}
                  display={stateObj.displayFrame}
                  className={classes.viewStyle}
                />
              </div>
              {renderDesign()}
            </div>
          </Paper>
        </div>
      )}
    </div>
  );

}

function mapStateToProps({ firebaseRealTime, user }) {
  const { generalConfig = {} } = firebaseRealTime;
  const { shopId = '' } = user;
  const { webapp = {}, terminal = {}, qrcode = {}, url = '', secondaryColor = '' } = generalConfig;
  const {
    url: oldUrl = '',
    images = {},
    productStyle = '',
    sectionOrientation = '',
    phrases = {}
  } = webapp;
  const { cartPhrase } = phrases;
  const { imageCoverOrderUrl = '' } = images;

  return {
    url: url || oldUrl,
    terminal,
    cartPhrase,
    imageCoverOrderUrl,
    webapp,
    qrcode,
    productStyle,
    sectionOrientation,
    secondaryColor,
    shopId
  };
}

WebDesign.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(WebDesign)));
